import React from 'react';
import { Link } from "react-router-dom";

class SharedExperimentRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: props.id,
            name: props.name,
            ownerMail: props.ownerMail,
            rights: props.rights,
            status: props.status,
            jwtToken: props.jwtToken
        };
        this.updateTable = this.updateTable.bind(this);
    }

    updateTable(){
        this.props.handler();
    }

    render() {
        return (
        <>
            <tr>
                <td>{this.state.name}</td>
                <td>{this.state.ownerMail}</td>
                <td>{this.state.rights}</td>
                <td>{this.state.status}</td>
                <td>
                    <Link to={"/detail/" + this.state.id}>
                        <span title="Show details" className="glyphicon glyphicon-eye-open" />
                    </Link>
                </td>
                <td>
                    {( (this.state.status === "EDIT" || this.state.status === "DEBUG")
                        && (this.state.rights === "EDIT" || this.state.rights === "SHARE" || this.state.rights === "OWNER") ) ?
                        <Link to={"/edit/" + this.state.id}>
                            <span title="Edit experiment" className="glyphicon glyphicon-edit" />
                        </Link> :
                        <span className="glyphicon glyphicon-edit" />
                    }
                </td>
                <td>
                    {(this.state.rights === "SHARE") ?
                        <Link to={"/share/" + this.state.id}>
                            <span title="Share experiment" className="glyphicon glyphicon-share-alt" />
                        </Link> :
                        <span title="Share experiment" className="glyphicon glyphicon-share-alt" />
                    }
                </td>
            </tr>
        </>
        );
    }
}

export default SharedExperimentRow;